import { Component,Input, output } from  '@angular/core';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { defaultVideoProperties, videoProperties } from '../cockpitDesigner.models';

@Component({
  selector: 'app-cockpit-designer-video-options',
  templateUrl: 'video-options.component.html',
  styleUrl: 'video-options.component.css',
  imports: [MatSlideToggleModule],
})

export class CockpitDesignerVideoOptions {

   @Input() videoProperties: videoProperties = defaultVideoProperties
   onVideoOptionsChange = output<videoProperties>();
  
   handleToggleChange(){
    this.onVideoOptionsChange.emit({
      ...this.videoProperties,
      videoEnabled: !this.videoProperties.videoEnabled
    })
   }
   
}